import { ref } from 'vue/dist/vue.esm-bundler'

export default {
    name: 'HelloWorld',
    setup() {
        const message = ref('Hello from Vue.js!')
        const greeting = ref('Hello World!')
        const description = ref('This is a Vue component loaded from a separate file!')
        const buttonText = ref('Click me!')
        const clickCount = ref(0)
        
        const updateGreeting = () => {
            clickCount.value++
            greeting.value = `Hello World! (Clicked ${clickCount.value} times)`
            message.value = `You've clicked the button ${clickCount.value} time${clickCount.value === 1 ? '' : 's'}!`
            
            if (clickCount.value === 1) {
                buttonText.value = 'Click again!'
            } else if (clickCount.value >= 5) {
                buttonText.value = 'You love clicking!'
                description.value = 'Wow, you really enjoy interacting with this Vue component! 🎉'
            } else {
                buttonText.value = 'Keep clicking!'
            }
        }
        
        return {
            message,
            greeting,
            description,
            buttonText,
            updateGreeting
        }
    },
    template: `
        <div class="kt-card-content p-6 text-center">
            <h3 class="text-2xl font-bold text-primary mb-2">{{ greeting }}</h3>
            <p class="text-secondary-foreground mb-4">{{ description }}</p>
            <button @click="updateGreeting" class="kt-btn kt-btn-primary">
                {{ buttonText }}
            </button>
            <p class="text-sm text-secondary-foreground mt-4">
                Current message: "{{ message }}"
            </p>
        </div>
    `
} 